<template>
    <form name="PayForm_DataCap" id="payment_form"  :style="{display:show}">
        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="cardNumber">Card Number</label>
                    <div class="input-group">
                        <input type="text" class="form-control" data-token="card_number" placeholder="Valid Card Number" required="" autofocus="">
                        <input type="hidden" id="token">
                        <span class="input-group-addon"><i class="fa fa-credit-card"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-4 col-md-4">
                <div class="form-group">
                    <label>Exp Month</label>
                    <input type="text" class="form-control" data-token="exp_month" placeholder="MM" maxlength="2" required="">
                </div>
            </div>
            <div class="col-xs-4 col-md-4">
                <div class="form-group">
                    <label>Exp Year</label>
                    <input type="text" class="form-control" data-token="exp_year" placeholder="YYYY" maxlength="4" required="">
                </div>
            </div>
            <div class="col-xs-4 col-md-4 pull-right">
                <div class="form-group">
                    <label>CVV Code</label>
                    <input type="text" class="form-control" data-token="cvv" placeholder="CVV" maxlength="4" required="">
                </div>
            </div>
            <div class="col-md-12">
                <button class="btn btn-primary pay" v-on:click="pay1">Pay</button>
            </div>
        </div>
    </form>
</template>
<!-- Scripts-->
<script>
export default {
  name: "PayForm_DataCap",
  data() {
    return {
      show: "none",
    }
  },
  methods: {
      showForm(bool){
          this.show = bool?"block":"none";
      },
      pay1(e){
          e.preventDefault();
          this.$parent.payDataCap();
      }
  },
  created() {

  },
  mounted() {   
    
  }
};
</script>
<!-- Styles -->
<style scoped>
</style>